<template>
  <VBtn class="link" flat :disabled="isDisabled || isDisabledByTimer" @click="handleSendEmail">{{
    title
  }}</VBtn>
</template>

<script lang="ts" setup>
  // Config
  import { RESEND_TIMER_IN_SECONDS } from '~/modules/manager/company/users/send-email/config';

  // Composables
  import { useTimerLabel } from '~/composables/use-timer-label';

  // Types
  import type { ManagerUserModel } from '~/modules/manager/models/user';

  // Components
  import VBtn from '~/misc/v-btn';

  const props = defineProps({
    userId: {
      type: Number,
      required: true,
    },
    model: {
      type: Object as PropType<ManagerUserModel>,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  });

  const {
    title,
    isDisabled: isDisabledByTimer,
    launchTimer,
  } = useTimerLabel('Send email', RESEND_TIMER_IN_SECONDS);

  const handleSendEmail = async () => {
    if (props.isDisabled || isDisabledByTimer.value) return;

    try {
      await props.model.sendLoginEmail(props.userId);

      launchTimer();
    } catch (error) {
      throw new Error('Failed to send email');
    }
  };
</script>
